import { Download } from "lucide-react";
import { useState } from "react";
import { montageApi } from "../api";
import { notify } from "../lib/notify";
import { cn } from "../lib/utils";

/**
 * «Скачать оригинал» (08.10.2026). Ролики Akorda, ИИ и YouTube в Telegram не
 * уходят — забрать файл можно только с сайта. Ссылка подписана на час и
 * отдаёт файл как вложение, под его исходным именем.
 */
export function DownloadOriginal({ taskId, itemId, n, className }: { taskId: string; itemId: string; n?: number; className?: string }) {
  const [busy, setBusy] = useState(false);
  return (
    <button
      type="button"
      disabled={busy}
      onClick={async (e) => {
        e.stopPropagation();
        setBusy(true);
        try {
          const { url } = await montageApi.downloadItem(taskId, itemId, n);
          window.open(url, "_blank", "noopener");
        } catch (error) {
          notify((error as Error).message || "Не удалось скачать", { icon: "rework" });
        } finally {
          setBusy(false);
        }
      }}
      className={cn("inline-flex shrink-0 items-center gap-1 text-xs font-medium text-muted-foreground underline underline-offset-2 hover:text-foreground disabled:opacity-50", className)}
    >
      <Download className="size-3.5" />
      Скачать
    </button>
  );
}
